import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ExclamationMarkIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.177 6.62v7.762h-2.354V6.62zm0 9.088v2.085h-2.354v-2.085z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
